import { useMemo } from 'react';
import liff from '@line/liff';

export default function useLineEnv() {
    const isInLineAppBrowser = useMemo(
        () => navigator.userAgent.toLowerCase().includes('line'),
        []
    );
    const isInLiffBrowser = useMemo(() => liff.isInClient(), []);

    return { isInLiffBrowser, isInLineAppBrowser };
}
